export default __webpack_public_path__ + "static/media/ISEO CLASS-6 EXAM PATTERN 2026-27.8ffdac1c.pdf";